// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__m79iz","leftSide":"styles_leftSide__YjEFG","rightSide":"styles_rightSide__cbgs4"};